import { render, staticRenderFns } from "./keyWords.vue?vue&type=template&id=3f3d0a9c&scoped=true&"
import script from "./keyWords.vue?vue&type=script&lang=js&"
export * from "./keyWords.vue?vue&type=script&lang=js&"
import style0 from "./keyWords.vue?vue&type=style&index=0&id=3f3d0a9c&prod&lang=css&"
import style1 from "./keyWords.vue?vue&type=style&index=1&id=3f3d0a9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3d0a9c",
  null
  
)

export default component.exports